// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Injectable } from '@angular/core';
import { LoadingStatus, needsLoading, Loaded, Role, MaybeLoadable, Loadable, ScopeCategory, ScopeConstraint } from '@app/core';
import { Observable, of } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { State, selectRoles, LoadingRolesAction, SelectRoleAction, RemoveRoleByIdAction,
    selectScopeCategories,
    LoadingScopeCategoriesAction,
    selectScopeConstraints,
    LoadingScopeConstraintsAction} from '@app/access-management/state';
import { take, filter, map, tap } from 'rxjs/operators';

const shouldLoad = (data: any) => needsLoading(data);
const hasData = (data: any) => !needsLoading(data);


@Injectable({providedIn: 'root'})
export class RoleScopeFacadeService {

    categories$: Observable<any> = of();
    constrains$: Observable<any> = of();

    constructor(private store: Store<State>) {}

      initializeCategories () {
        const categoriesStore$ = this.store.pipe(select(selectScopeCategories));

        categoriesStore$.pipe(
            take(1), filter((scopeCategoriesState) =>
                !scopeCategoriesState || scopeCategoriesState.status === LoadingStatus.LOAD_FAILED ))
        .subscribe(() => this.store.dispatch(new LoadingScopeCategoriesAction()));

       this.categories$ = categoriesStore$.pipe(
           filter((scopeCategoriesState) =>
               !!scopeCategoriesState && scopeCategoriesState.status === LoadingStatus.LOAD_COMPLETE),
           map((scopeCategoriesState: any) => scopeCategoriesState.data)
       );
      }

      initializeConstrains(categoryId: string) {

        const constrainsStore$ = this.store.pipe(select(selectScopeConstraints(categoryId)));
        constrainsStore$.pipe(
            take(1), filter((constrainState) =>
                !constrainState || constrainState.status === LoadingStatus.LOAD_FAILED ))
        .subscribe(() => this.store.dispatch(new LoadingScopeConstraintsAction(categoryId)));

        this.constrains$ = constrainsStore$.pipe(
            filter((state) =>
                !!state && state.status === LoadingStatus.LOAD_COMPLETE),
            map((state: any) => state.data)
        );
      }

}



// WEBPACK FOOTER //
// ./src/app/access-management/state/role-scole.facade.ts